<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=DM+Serif+Display&display=swap');

* {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  box-sizing: border-box;
}

.login-page {
  height: 100vh;
  display: flex;
  background: #ededf8;
  overflow: hidden;
}

/* ── Left brand panel ── */
.brand-panel {
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #1e3592;
  overflow: hidden;
  padding: 40px 48px;
}
.brand-panel::before {
  content: '';
  position: absolute;
  top: -120px;
  right: -120px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: rgba(59,76,192,0.15);
  filter: blur(80px);
}
.brand-panel::after {
  content: '';
  position: absolute;
  bottom: -80px;
  left: -80px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(91,141,239,0.12);
  filter: blur(60px);
}
.brand-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.brand-logo {
  height: 40px;
  width: auto;
  margin-bottom: 20px;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}
.brand-section-label {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 9px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: rgba(255,255,255,0.6);
  margin-bottom: 14px;
}
.brand-title {
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 26px;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.3;
}
.brand-title-coral {
  color: #E8726F;
}
.brand-subtitle {
  font-size: 13px;
  color: rgba(255,255,255,0.7);
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 28px;
}
.starr-acronym {
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
}
.starr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 56px;
}
.starr-letter {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}
.starr-icon {
  font-size: 18px !important;
  opacity: 0.9;
}
.starr-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(255,255,255,0.8);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.brand-footer-text {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: rgba(255,255,255,0.45);
  font-size: 12px;
  font-weight: 400;
  z-index: 2;
}

/* ── Right form panel ── */
.form-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 32px;
  position: relative;
  background: #ffffff;
}
.form-wrapper {
  width: 100%;
  max-width: 400px;
}
.form-heading {
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 26px;
  font-weight: 400;
  color: #1a1a3e;
  margin-bottom: 6px;
}
.form-sub {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 24px;
}
.input-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}
.forgot-link {
  color: #3B4CC0;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}
.forgot-link:hover {
  text-decoration: underline;
}
.sign-in-btn {
  text-transform: none !important;
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.2px !important;
  height: 48px !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(232,114,111,0.3), 0 4px 14px rgba(232,114,111,0.15) !important;
  transition: all 0.2s ease !important;
}
.sign-in-btn:hover {
  box-shadow: 0 4px 14px rgba(232,114,111,0.4), 0 8px 24px rgba(232,114,111,0.2) !important;
  transform: translateY(-1px);
}
.divider-row {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #9A96A8;
  font-size: 12px;
  margin: 16px 0;
}
.divider-row::before, .divider-row::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #EEECF5;
}
.links-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #5A5A72;
}
.links-sep { color: #EEECF5; }
.link-a {
  color: #3B4CC0;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.link-a:hover { text-decoration: underline; }
.form-footer {
  margin-top: 24px;
  text-align: center;
  font-size: 12px;
  color: #9A96A8;
}
.form-footer a {
  color: #5A5A72;
  text-decoration: none;
}
.form-footer a:hover { text-decoration: underline; }

/* ══════════════════════════════════════════════
   MOBILE RESPONSIVE — NO SCROLL, ALL CONTENT
   Strategy: compress sizes based on screen height
   All elements remain visible. Only on extreme
   short screens (<= 660px) subtitle is hidden.
   Ported from LoginExisting.vue for consistency.
   ══════════════════════════════════════════════ */

/* ── Base mobile layout (≤960px width, all heights) ── */
@media (max-width: 960px) {
  .login-page {
    flex-direction: column;
    overflow: hidden;
  }

  /* Brand panel: proportional height so form panel isn't too empty */
  .brand-panel {
    flex: 0 0 28vh;
    min-height: auto;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
  }
  .starr-acronym,
  .brand-footer-text {
    display: none;
  }
  .brand-logo {
    height: 45px;
    width: auto;
    margin-bottom: 3px;
  }
  .brand-section-label {
    font-size: 8px;
    margin-bottom: 4px;
  }
  .brand-title {
    font-size: 15px;
    margin-bottom: 6px;
    line-height: 1.25;
  }
  .brand-subtitle {
    display: none;
  }

  /* Form panel: fills remaining space, all items visible */
  .form-panel {
    flex: 1;
    min-height: 0;
    padding: 16px 24px;
    justify-content: center;
    overflow: hidden;
  }
  .form-wrapper {
    max-width: 100%;
  }
  .form-heading {
    font-size: 18px;
    margin-bottom: 2px;
  }
  .form-sub {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .divider-row {
    margin: 8px 0;
  }
  .links-row {
    font-size: 13px;
  }
  .form-footer {
    margin-top: 8px;
    font-size: 11px;
  }
}

/* ── Height 760px–900px: medium phones (iPhone XR, 13, 14) ── */
@media (max-width: 960px) and (min-height: 760px) and (max-height: 900px) {
  .brand-panel {
    flex: 0 0 30vh;
    padding: 18px 28px;
  }
  .brand-logo {
    height: 65px;
    width: auto;
    margin-bottom: 12px;
  }
  .brand-section-label {
    font-size: 10px;
    margin-bottom: 8px;
  }
  .brand-title {
    font-size: 19px;
    line-height: 1.35;
    margin-bottom: 0;
  }
  .brand-subtitle {
    display: none;
  }
  .form-panel {
    padding: 18px 24px;
  }
  .form-heading {
    font-size: 20px;
    margin-bottom: 4px;
  }
  .form-sub {
    font-size: 12px;
    margin-bottom: 12px;
  }
  .divider-row {
    margin: 10px 0;
  }
  .form-footer {
    margin-top: 10px;
    font-size: 12px;
  }
}

/* ── Height >900px: large phones (iPhone 14 Pro Max, 15 Plus, big Android) ── */
@media (max-width: 960px) and (min-height: 901px) {
  .brand-panel {
    flex: 0 0 32vh;
    padding: 20px 28px;
  }
  .brand-logo {
    height: 80px;
    width: auto;
    margin-bottom: 16px;
  }
  .brand-section-label {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .brand-title {
    font-size: 24px;
    line-height: 1.35;
    margin-bottom: 0;
  }
  .brand-subtitle {
    display: none;
  }
  .form-panel {
    padding: 24px 24px;
  }
  .form-heading {
    font-size: 22px;
    margin-bottom: 6px;
  }
  .form-sub {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .divider-row {
    margin: 14px 0;
  }
  .form-footer {
    margin-top: 14px;
    font-size: 12px;
  }
}

/* ── Height ≤660px: very short (iPhone SE 667px, landscape)
   Only here do we hide subtitle to gain space ── */
@media (max-width: 960px) and (max-height: 660px) {
  .brand-panel {
    padding: 10px 24px;
  }
  .brand-subtitle {
    display: none;
  }
  .brand-section-label {
    display: none;
  }
  .brand-title {
    font-size: 13px;
    margin-bottom: 0;
  }
  .form-panel {
    padding: 12px 24px;
  }
  .form-heading {
    font-size: 16px;
  }
  .form-sub {
    font-size: 10px;
    margin-bottom: 8px;
  }
  .divider-row {
    margin: 6px 0;
  }
  .form-footer {
    margin-top: 6px;
    font-size: 10px;
  }
}

/* ── Height ≤560px: landscape / extreme short — hide brand panel entirely ── */
@media (max-width: 960px) and (max-height: 560px) {
  .brand-panel {
    display: none;
  }
  .form-panel {
    padding: 8px 24px;
  }
}
</style>

<style>
.login-page .v-text-field--outlined fieldset {
  border-color: #e0e0f0 !important;
  border-radius: 10px !important;
  border-width: 1.5px !important;
  transition: border-color 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #3B4CC0 !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 3px rgba(59,76,192,0.08);
}
.login-page .v-input__slot {
  min-height: 44px !important;
  background: #F5F4FA !important;
  border-radius: 10px !important;
  transition: background 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}
.login-page .v-text-field {
  text-align: left;
}
.login-page .v-text-field input {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #1E1E2F !important;
}
.login-page .v-text-field input::placeholder {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 14px;
  color: #9ca3af !important;
  font-weight: 400;
  opacity: 1 !important;
}
.login-page .v-input__prepend-inner,
.login-page .v-input__append-inner {
  margin-top: 12px !important;
}
.login-page .v-input__prepend-inner .v-icon,
.login-page .v-input__append-inner .v-icon {
  color: #9A96A8 !important;
  font-size: 20px !important;
  transition: color 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused .v-input__prepend-inner .v-icon {
  color: #3B4CC0 !important;
}
</style>

<template>
  <v-app>
    <v-overlay :value="overlay_load" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="login-page">
      <!-- Left brand panel — mirrors LoginExisting.vue exactly -->
      <div class="brand-panel">
        <div class="brand-content">
          <img src="@/assets/starr.png" alt="STARR" class="brand-logo" />
          <p class="brand-section-label">PARTNER PORTAL</p>
          <h1 class="brand-title">Turning enterprise goals into<br/><span class="brand-title-coral">measured results.</span></h1>
          <p class="brand-subtitle">
            STARR is the first Management Operating System that institutionalises ownership, enforces cadence, and makes execution predictable &mdash; so your business runs even when leadership is absent.
          </p>
          <div class="starr-acronym">
            <div class="starr-item">
              <span class="starr-letter" style="background: #3B4CC0;">S</span>
              <v-icon class="starr-icon" style="color: #3B4CC0 !important;">mdi-target</v-icon>
              <span class="starr-label">Strategy</span>
            </div>
            <div class="starr-item">
              <span class="starr-letter" style="background: #4B7BC5;">T</span>
              <v-icon class="starr-icon" style="color: #4B7BC5 !important;">mdi-account-group</v-icon>
              <span class="starr-label">Team</span>
            </div>
            <div class="starr-item">
              <span class="starr-letter" style="background: #E8726F;">A</span>
              <v-icon class="starr-icon" style="color: #E8726F !important;">mdi-flash</v-icon>
              <span class="starr-label">Activate</span>
            </div>
            <div class="starr-item">
              <span class="starr-letter" style="background: #8B6BAE;">R</span>
              <v-icon class="starr-icon" style="color: #8B6BAE !important;">mdi-clipboard-check</v-icon>
              <span class="starr-label">Review</span>
            </div>
            <div class="starr-item">
              <span class="starr-letter" style="background: #0D9488;">R</span>
              <v-icon class="starr-icon" style="color: #0D9488 !important;">mdi-trophy</v-icon>
              <span class="starr-label">Reward</span>
            </div>
          </div>
        </div>
        <div class="brand-footer-text">Trusted by organizations worldwide</div>
      </div>

      <!-- Right form panel -->
      <div class="form-panel">
        <div class="form-wrapper">
          <h2 class="form-heading">Welcome, Partner</h2>
          <p class="form-sub">Sign in to your partner account</p>

          <label class="input-label">Email <span style="color: #f1416c">*</span></label>
          <v-text-field
            v-model="email"
            placeholder="Enter your email"
            outlined
            prepend-inner-icon="mdi-email-outline"
            @keypress.enter="$refs.pwd_field.focus()"
            color="#3B4CC0"
            hide-details
            style="margin-bottom: 12px"
            :disabled="overlay_load"
          />

          <label class="input-label">Password <span style="color: #f1416c">*</span></label>
          <v-text-field
            v-model="password"
            placeholder="Enter your password"
            :type="showPassword ? 'text' : 'password'"
            outlined
            ref="pwd_field"
            prepend-inner-icon="mdi-lock-outline"
            :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            @click:append="showPassword = !showPassword"
            @keypress.enter="validate()"
            color="#3B4CC0"
            hide-details
            style="margin-bottom: 8px"
            :disabled="overlay_load"
          />

          <div class="d-flex justify-end" style="margin-bottom: 16px">
            <span class="forgot-link" @click="forgot">Forgot password?</span>
          </div>

          <v-btn
            block
            dark
            color="#E8726F"
            class="sign-in-btn"
            :loading="overlay_load"
            @click="validate()"
            elevation="0"
          >
            Sign In
          </v-btn>

          <div class="divider-row"><span>or</span></div>

          <div class="links-row">
            <span class="link-a" @click="goCustomerLogin">Customer login</span>
            <span class="links-sep">·</span>
            <span class="link-a" @click="goPartnerSignup">Partner signup</span>
          </div>

          <div class="form-footer">
            <span>By signing in, you agree to our </span>
            <a href="https://starrboard.com/terms-of-use" target="_blank">Terms</a>
            <span> &amp; </span>
            <a href="https://starrboard.com/privacy-policy" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import Package from "/package.json";

export default {
  name: "LoginPartner",
  async mounted() {
    // If not on partner.* subdomain in prod, still allow localhost dev
    let domain = window.location.host.split(".");
    if (
      domain.length === 0 ||
      domain == null ||
      domain == "" ||
      domain == undefined ||
      domain == "localhost"
    ) {
      this.prefixflag = true;
    }

    // Magic-link auto-login: if a token is in the URL, skip the form and sign in directly
    const token = this.$route.query.token;
    if (token) {
      this.overlay_load = true;
      try {
        const res = await this.$papi.get("public/partner_magic_login", { params: { token } });
        const d = res.data;
        if (d.result === "success") {
          // Store session — same keys as PartnerMagicLogin.vue uses
          localStorage.setItem("PARTNER_TOKEN",   d.token);
          localStorage.setItem("PARTNER_ID",      String(d.partner_id   || ""));
          localStorage.setItem("PARTNER_NAME",    d.partner_name || d.name || "");
          localStorage.setItem("PARTNER_COMPANY", d.company_name || "");
          localStorage.setItem("PARTNER_EMAIL",   d.email        || "");
          // needs_set_password: true on first magic-link login — let them set a password
          if (d.needs_set_password) {
            this.$router.replace("/partner_magic?_authed=1");
          } else {
            this.$router.replace("/partner_landing_v2");
          }
        } else {
          this.global_push_toast("error", d.error || "Magic link login failed. Please log in manually.");
          this.overlay_load = false;
        }
      } catch (err) {
        const msg = err.response?.data?.error || "This login link is invalid or has already been used.";
        this.global_push_toast("error", msg);
        this.overlay_load = false;
      }
    }
  },
  data() {
    return {
      applicationVersion: Package.version,
      email: "",
      password: "",
      showPassword: false,
      overlay_load: false,
      prefix: null,
      prefixflag: false,
    };
  },
  methods: {
    validate() {
      const email = this.email ? this.email.trim() : "";
      const password = this.password ? this.password.trim() : "";

      if (!email || !password) {
        this.global_push_toast(
          "error",
          "[ERR_AUTH_001] Email and password are required"
        );
        return;
      }

      this.overlay_load = true;

      // Partner login always goes through the public partner_login API
      this.$papi
        .post("public/partner_login", { email, password })
        .then((res) => {
          this.overlay_load = false;
          if (res.data.result !== "success") {
            this.global_push_toast(
              "error",
              "[ERR_AUTH_001] " + (res.data.message || "Invalid credentials")
            );
            return;
          }
          const d = res.data;
          localStorage.setItem("resultat", this.applicationVersion);
          localStorage.setItem("TOKEN", d.token);
          localStorage.setItem("USER_ID", d.user_id);
          localStorage.setItem("USER_EMAIL", d.email);
          localStorage.setItem("USER_NAME", d.partner_name);
          localStorage.setItem("domain", "admin");
          localStorage.setItem("PARTNER_ID", d.partner_id);
          localStorage.setItem("PARTNER_NAME", d.partner_name);
          localStorage.setItem("COMPANY_NAME", d.company_name);
          localStorage.setItem("IS_ADMIN", "false");
          // Store screen & module rights for partner role
          localStorage.setItem(
            "COMMON_SCREEN_RIGHT_DATASET",
            JSON.stringify(d.common_screen_dataset || [])
          );
          localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify([]));
          localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify([]));
          localStorage.setItem("tectalik_product_list", []);
          localStorage.setItem("features_list", []);
          if (d.user_type_code) {
            localStorage.setItem("USER_TYPE", d.user_type_code);
            localStorage.setItem("USER_TYPES", d.user_type_code);
          }
          this.$router.push({ path: "/partner_landing_v2" });
        })
        .catch((err) => {
          this.overlay_load = false;
          const code = err.response?.status || "ERR";
          this.global_push_toast(
            "error",
            `[ERR_AUTH_002] Partner login failed (${code})`
          );
        });
    },
    forgot() {
      this.$router.push({
        path: "/forgotpassword_admin?email=" + this.email,
      });
    },

    goCustomerLogin() {
      const env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
      let url;
      if (env === 'production') {
        url = 'https://app.starrboard.com/login';
      } else if (env === 'development') {
        url = 'https://starrboard.in/login';
      } else {
        url = 'http://starrboard.in:8080/login';
      }
      window.location.href = url;
    },

    goPartnerSignup() {
      const env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
      let url;
      if (env === 'production') {
        url = 'https://starrboard.com/partner-signup';
      } else if (env === 'development') {
        url = 'https://devpartner.starrboard.com/partner-signup';
      } else {
        url = 'http://localhost:3000/partner-signup';
      }
      window.location.href = url;
    },
  },
};
</script>